import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    id: "header",
    class: _normalizeClass(["w-full z-40", [ {'fixed' : !$props.editMode}, $options.topMarginHeader ]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}